import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';
import { Box, Button, CloseButton, Loader, Modal } from '@wix/design-system';
import { DomainInsight } from './DomainInsight';
import { LegalDisclaimer } from './LegalDisclaimer';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const AiInsightsModal = _ref => {
  let {
    isOpen,
    onClose,
    onGetIt,
    ...insightProps
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const [isGetItLoading, setIsGetItLoading] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsGetItLoading(false);
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onRequestClose: onClose,
    shouldCloseOnOverlayClick: true,
    transition: "moveVertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    position: "absolute",
    bottom: "12px",
    left: "12px",
    right: "12px",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0px 20px 30px 0px rgba(19, 23, 32, 0.1)"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "right",
    padding: "SP3 SP3 0",
    width: "100%",
    position: "absolute"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    skin: "standardFilled",
    size: "medium",
    onClick: onClose
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "SP6",
    gap: "SP5"
  }, /*#__PURE__*/React.createElement(DomainInsight, _extends({}, insightProps, {
    sslCertificate: false,
    showLegalDisclaimer: false,
    withCard: false
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "0 SP6 SP6",
    gap: "SP4"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    skin: "dark",
    fullWidth: true,
    disabled: isGetItLoading,
    onClick: () => {
      setIsGetItLoading(true);
      onGetIt();
    }
  }, isGetItLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_suite.domain_gate.suggestions.card.cta')), /*#__PURE__*/React.createElement(Box, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(LegalDisclaimer, null)))));
};
//# sourceMappingURL=AiInsightsModal.js.map